function englishProductTitleFromCartItem(item) {
  const handle = String(item?.handle || '')
    .toLowerCase()
    .replace(/^.*\/products\//, '')
    .split('?')[0]
    .replace(/\/$/, '');
  const byHandle = {
    'the-legging': 'The Legging — Reboot Series',
    'the-bike-short': 'The Bike Short — Reboot Series',
    'the-bra-tank': 'The Bra Tank — Reboot Series',
    'the-fitted-tee': 'The Fitted Tee — Reboot Series',
    'the-oversized-tee': 'The Oversized Tee — Reboot Series',
    'the-wrap-short': 'The Wrap Short',
    'the-wide-leg-pant': 'The Wide-Leg Pant',
    'the-windbreaker': 'The Windbreaker',
    'aj-bl01': 'The Wrap Blouse — Studio Flow',
    'aj-bt02': 'The Bra Top — Studio Flow',
    'aj-fl01': 'The Flare Legging — Studio Flow',
    'aj-sh05': 'The Shorts — Studio Flow',
    'aj-ts03': 'The Polo — Studio Flow',
  };
  if (byHandle[handle]) return byHandle[handle];
  const fromUrl = String(item?.url || '').match(/\/products\/([^/?#]+)/i);
  if (fromUrl && byHandle[fromUrl[1].toLowerCase()]) return byHandle[fromUrl[1].toLowerCase()];
  const lang = document.documentElement.lang?.slice(0, 2)?.toLowerCase();
  if (lang && lang !== 'en') {
    if (handle) {
      return handle
        .split('-')
        .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : ''))
        .join(' ');
    }
  }
  return item.product_title || item.title || '';
}

function syncHomeHeaderState() {
  const header = document.querySelector('.site-header--home');
  if (!header) return;

  const hero = document.querySelector('.hero-section');
  const announcement = document.querySelector('.announcement-wrap');
  if (!hero) return;

  const heroHeight = Math.max(1, hero.offsetHeight);
  const rect = hero.getBoundingClientRect();
  const scrolledPastHeroTop = Math.max(0, -rect.top);
  /** Доля первого блока (героя), уже проскролленная: 0…1 */
  const heroScrollFraction = Math.min(1, scrolledPastHeroTop / heroHeight);
  /** Лого на месте и белый хедер после 60% скролла первого блока */
  const settleAt = 0.6;
  const progress = Math.min(1, heroScrollFraction / settleAt);
  const passedHero = heroScrollFraction >= settleAt;

  header.style.setProperty('--hero-progress', String(progress));
  if (announcement) {
    announcement.style.setProperty('--hero-progress', String(progress));
  }

  header.classList.toggle('is-scrolled', passedHero);
  if (announcement) {
    announcement.classList.toggle('is-hidden', passedHero);
  }

  if (header.classList.contains('nav-dropdown-open')) {
    syncSearchOverlayHeaderOffset();
  }
}

function startAnnouncementRotator() {
  const rotators = document.querySelectorAll('[data-announcement-rotator]');
  rotators.forEach((rotator) => {
    const messages = rotator.querySelectorAll('[data-announcement-message]');
    if (messages.length <= 1) return;

    const interval = Number(rotator.getAttribute('data-interval')) || 4000;
    let index = 0;

    window.setInterval(() => {
      messages[index].classList.remove('is-active');
      index = (index + 1) % messages.length;
      messages[index].classList.add('is-active');
    }, interval);
  });
}

function initProductCards() {
  document.querySelectorAll('[data-product-card]').forEach((card) => {
    const form = card.querySelector('[data-product-add-form]');
    const variantInput = form?.querySelector('[data-product-variant-id]');
    const variantsJson = card.querySelector('[data-product-variants]');
    const optionsJson = card.querySelector('[data-product-options]');
    if (!form || !variantInput || !variantsJson || !optionsJson) return;

    let variants = [];
    let options = [];
    try {
      variants = JSON.parse(variantsJson.textContent || '[]');
      options = JSON.parse(optionsJson.textContent || '[]');
    } catch {
      return;
    }

    const optionNames = options.map((o) => String(o.name || '').toLowerCase().trim());
    const sizeIndex = optionNames.findIndex((name) => name.includes('size') || name.includes('размер'));
    const colorIndex = optionNames.findIndex((name) => name.includes('color') || name.includes('colour') || name.includes('цвет'));
    const hasColorFlow = colorIndex >= 0;
    const sizeGroup = card.querySelector('[data-size-group]');
    const colorGroup = card.querySelector('[data-color-group]');
    const preorderEnabled = card.getAttribute('data-preorder-enabled') === 'true';

    const getOptionValue = (variant, idx) => {
      if (idx === 0) return variant.option1;
      if (idx === 1) return variant.option2;
      if (idx === 2) return variant.option3;
      return null;
    };

    const animateToCart = () => {
      const cartTarget = document.querySelector('.cart-toggle') || document.querySelector('[data-cart-toggle]');
      if (!cartTarget) return Promise.resolve();
      cartTarget.classList.add('is-bump');
      return new Promise((resolve) => {
        window.setTimeout(() => {
          cartTarget.classList.remove('is-bump');
          resolve();
        }, 220);
      });
    };

    const findVariant = (sizeValue, colorValue) => variants.find((variant) => {
      if (!preorderEnabled && !variant.available) return false;
      const matchesSize = sizeIndex < 0 || !sizeValue || getOptionValue(variant, sizeIndex) === sizeValue;
      const matchesColor = colorIndex < 0 || !colorValue || getOptionValue(variant, colorIndex) === colorValue;
      return matchesSize && matchesColor;
    });

    const setPickerActive = (selector, attr, value) => {
      card.querySelectorAll(selector).forEach((btn) => {
        const on = value != null && btn.getAttribute(attr) === value;
        btn.classList.toggle('product-card__size-btn--active', on);
        btn.classList.remove('is-active');
      });
    };

    const clearPickerActive = (selector) => {
      card.querySelectorAll(selector).forEach((btn) => {
        btn.classList.remove('product-card__size-btn--active', 'is-active');
      });
    };

    const submitButton = form.querySelector('.product-card__add-btn');
    let selectedSize = null;
    let selectedColor = null;

    const updateSelectedVariant = () => {
      const needsSize = sizeIndex >= 0;
      if (needsSize && !selectedSize) {
        if (submitButton) submitButton.disabled = true;
        return null;
      }
      if (hasColorFlow && !selectedColor) {
        if (submitButton) submitButton.disabled = true;
        return null;
      }
      const variant = findVariant(selectedSize, hasColorFlow ? selectedColor : null);
      if (variant) {
        variantInput.value = String(variant.id);
      }
      if (submitButton) {
        // Pre-order mode: button stays disabled (email waitlist only; no purchase)
        submitButton.disabled = preorderEnabled ? true : !variant;
      }
      return variant;
    };

    const addVariantToCart = async (variantId) => {
      if (preorderEnabled) return;
      if (!variantId) return;
      variantInput.value = String(variantId);
      await animateToCart();
      const fd = new FormData(form);
      fd.set('id', String(variantId));
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) return;
        const cartRes = await fetch('/cart.js');
        if (cartRes.ok) {
          const cart = await cartRes.json();
          await refreshCartDrawer(cart);
        } else {
          await refreshCartDrawer();
        }
        setCartDrawerState(true);
      } catch {
        form.submit();
      }
    };

    card.querySelectorAll('[data-size-value]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const sizeValue = btn.getAttribute('data-size-value');
        if (!sizeValue) return;
        selectedSize = sizeValue;

        if (hasColorFlow) {
          selectedColor = null;
          setPickerActive('[data-size-value]', 'data-size-value', sizeValue);
          if (colorGroup) colorGroup.hidden = false;
          clearPickerActive('[data-color-value]');
          card.querySelectorAll('[data-color-value]').forEach((colorBtn) => {
            const colorValue = colorBtn.getAttribute('data-color-value');
            const availableVariant = findVariant(sizeValue, colorValue);
            colorBtn.disabled = !availableVariant;
            colorBtn.classList.toggle('product-card__size-btn--disabled', !availableVariant);
          });
        } else {
          setPickerActive('[data-size-value]', 'data-size-value', sizeValue);
        }
        updateSelectedVariant();
      });
    });

    card.querySelectorAll('[data-color-value]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const colorValue = btn.getAttribute('data-color-value');
        if (!colorValue || !selectedSize) return;
        setPickerActive('[data-color-value]', 'data-color-value', colorValue);
        selectedColor = colorValue;
        updateSelectedVariant();
      });
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variant = updateSelectedVariant();
      if (!variant) return;
      await addVariantToCart(variant.id);
    });

    if (hasColorFlow) {
      if (colorGroup) colorGroup.hidden = true;
      if (sizeGroup) sizeGroup.hidden = false;
      clearPickerActive('[data-size-value]');
      clearPickerActive('[data-color-value]');
      selectedSize = null;
      selectedColor = null;
    } else {
      const initialSizeBtn = card.querySelector('[data-size-value].product-card__size-btn--active');
      if (initialSizeBtn) {
        selectedSize = initialSizeBtn.getAttribute('data-size-value');
      }
    }
    updateSelectedVariant();
  });
}

function initReactParityCarousels() {
  const carousels = document.querySelectorAll('[data-react-carousel]');
  carousels.forEach((carousel) => {
    const viewport = carousel.querySelector('[data-carousel-viewport]');
    const track = carousel.querySelector('[data-carousel-track]');
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    if (!viewport || !track || !prev || !next) return;

    const cards = Array.from(track.querySelectorAll('.product-card'));
    if (!cards.length) return;

    let index = 0;
    const gap = 2;

    const getCardWidth = () => cards[0].getBoundingClientRect().width + gap;
    const getVisibleCount = () => {
      const cardWidth = getCardWidth();
      return Math.max(1, Math.floor((viewport.clientWidth + gap) / cardWidth));
    };
    const getMaxIndex = () => Math.max(0, cards.length - getVisibleCount());

    const update = () => {
      const cardWidth = getCardWidth();
      const maxIndex = getMaxIndex();
      index = Math.max(0, Math.min(index, maxIndex));
      track.style.transform = `translateX(${-index * cardWidth}px)`;
      prev.disabled = index <= 0;
      next.disabled = index >= maxIndex;
    };

    prev.addEventListener('click', () => {
      const step = getVisibleCount();
      index = Math.max(0, index - step);
      update();
    });

    next.addEventListener('click', () => {
      const step = getVisibleCount();
      index = Math.min(getMaxIndex(), index + step);
      update();
    });

    update();
    window.addEventListener('resize', update, { passive: true });
  });
}

function initShopByColorProductGalleries() {
  document.querySelectorAll('.shop-by-color-products [data-product-gallery]').forEach((card) => {
    const slides = Array.from(card.querySelectorAll('.product-card__gallery-img:not(.product-card__img--placeholder)'));
    const dots = Array.from(card.querySelectorAll('[data-product-gallery-dot]'));
    const prev = card.querySelector('[data-product-gallery-prev]');
    const next = card.querySelector('[data-product-gallery-next]');
    let index = 0;

    const showSlide = (nextIndex) => {
      if (slides.length === 0) return;
      index = Math.max(0, Math.min(slides.length - 1, nextIndex));
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };

    if (slides.length <= 1) {
      showSlide(0);
      return;
    }

    prev?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      showSlide(index - 1);
    });

    next?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      showSlide(index + 1);
    });

    card.addEventListener('mouseleave', () => {
      showSlide(0);
    });

    showSlide(0);
  });
}

function initCustomScrollIndicators() {
  const scrollers = document.querySelectorAll('[data-custom-scroll-area]');
  scrollers.forEach((scroller) => {
    const section = scroller.closest('.react-parity-products, .shop-by-color-products, .color-section');
    const fakeTrack = section?.querySelector('.react-parity-products__fake-scroll, .shop-by-color-products__fake-scroll');
    const thumb = section?.querySelector('[data-custom-scroll-thumb]');
    if (!thumb || !fakeTrack) return;
    const cards = Array.from(scroller.querySelectorAll('.product-card'));
    const gap = 2;

    let isDragging = false;

    const syncScrollFromPointer = (clientX) => {
      const trackRect = fakeTrack.getBoundingClientRect();
      const thumbRect = thumb.getBoundingClientRect();
      const thumbWidth = thumbRect.width;
      const maxThumbTravel = Math.max(1, trackRect.width - thumbWidth);
      const maxScroll = Math.max(1, scroller.scrollWidth - scroller.clientWidth);
      const pointerX = Math.min(trackRect.right, Math.max(trackRect.left, clientX));
      const nextThumbX = Math.min(maxThumbTravel, Math.max(0, pointerX - trackRect.left - (thumbWidth / 2)));
      scroller.scrollLeft = (nextThumbX / maxThumbTravel) * maxScroll;
    };

    const updateThumb = () => {
      cards.forEach((card) => {
        card.style.flexBasis = '';
        card.style.maxWidth = '';
      });

      const isScrollable = scroller.scrollWidth > scroller.clientWidth + 1;
      fakeTrack.style.display = isScrollable ? 'block' : 'none';
      if (!isScrollable) {
        if (cards.length > 0) {
          const targetWidth = Math.max(0, (scroller.clientWidth - (gap * (cards.length - 1))) / cards.length);
          cards.forEach((card) => {
            card.style.flexBasis = `${targetWidth}px`;
            card.style.maxWidth = 'none';
          });
        }
        thumb.style.transform = 'translateY(-50%) translateX(0)';
        return;
      }

      const maxScroll = Math.max(1, scroller.scrollWidth - scroller.clientWidth);
      const visibleRatio = Math.min(1, scroller.clientWidth / scroller.scrollWidth);
      const thumbWidth = Math.max(42, Math.floor(scroller.clientWidth * visibleRatio));
      thumb.style.width = `${thumbWidth}px`;

      const trackWidth = scroller.clientWidth;
      const maxThumbTravel = Math.max(0, trackWidth - thumbWidth);
      const progress = scroller.scrollLeft / maxScroll;
      thumb.style.transform = `translateX(${Math.floor(maxThumbTravel * progress)}px)`;
    };

    thumb.addEventListener('mousedown', (event) => {
      event.preventDefault();
      isDragging = true;
      thumb.classList.add('is-dragging');
    });

    fakeTrack.addEventListener('mousedown', (event) => {
      event.preventDefault();
      syncScrollFromPointer(event.clientX);
      isDragging = true;
      thumb.classList.add('is-dragging');
    });

    window.addEventListener('mousemove', (event) => {
      if (!isDragging) return;
      event.preventDefault();
      syncScrollFromPointer(event.clientX);
    });

    window.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      thumb.classList.remove('is-dragging');
    });

    scroller.addEventListener('scroll', updateThumb, { passive: true });
    window.addEventListener('resize', updateThumb, { passive: true });
    updateThumb();
  });
}

function initCollectionsManualScroll() {
  const viewports = document.querySelectorAll('[data-autoscroll-viewport]');
  viewports.forEach((viewport) => {
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    viewport.addEventListener('mousedown', (event) => {
      isDown = true;
      startX = event.clientX;
      startScrollLeft = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      event.preventDefault();
    });

    window.addEventListener('mouseup', () => {
      isDown = false;
      viewport.classList.remove('is-dragging');
    });

    window.addEventListener('mousemove', (event) => {
      if (!isDown) return;
      const dx = event.clientX - startX;
      viewport.scrollLeft = startScrollLeft - dx;
      event.preventDefault();
    });

    viewport.addEventListener('wheel', (event) => {
      if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
        viewport.scrollLeft += event.deltaY;
        event.preventDefault();
      }
    }, { passive: false });
  });
}

function initVideoPromo() {
  const sections = document.querySelectorAll('.video-promo');
  sections.forEach((section) => {
    const media = section.querySelector('[data-video-promo-media]');
    if (!media) return;
    media.addEventListener('ended', () => {
      section.classList.add('is-ended');
    });
    media.addEventListener('play', () => {
      section.classList.remove('is-ended');
    });
  });
}

function getCartDrawerConfig() {
  const node = document.querySelector('[data-cart-drawer-config]');
  if (!node) return null;
  try {
    return JSON.parse(node.textContent || '{}');
  } catch {
    return null;
  }
}

function formatDrawerMoney(cents, template) {
  const value = Number(cents || 0);
  const amount = (value / 100).toFixed(2);
  const noDec = String(Math.round(value / 100));
  return String(template || '{{amount}}')
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, noDec)
    .replace(/\{\{\s*amount\s*\}\}/gi, amount);
}

function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text == null ? '' : String(text);
  return div.innerHTML;
}

const CART_DRAWER_REMOVE_ICON = `<svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>`;

function buildCartDrawerDynamicHtml(cart, cfg) {
  if (!cfg || !cart) return '';
  const labels = cfg.labels || {};
  const fmt = cfg.moneyFormat || '{{amount}}';
  const threshold = Number(cfg.freeShippingThreshold) || 10000;
  const shipPrice = Number(cfg.shippingPrice) || 1000;
  const totalPrice = Number(cart.total_price) || 0;
  let shippingCost = shipPrice;
  if (totalPrice >= threshold) shippingCost = 0;
  const totalWithShipping = totalPrice + shippingCost;

  const items = Array.isArray(cart.items) ? cart.items : [];
  if (items.length === 0 || Number(cart.item_count) === 0) {
    return `
      <div class="cart-drawer__empty">
        <p>${escapeHtml(labels.empty)}</p>
        <button type="button" class="button cart-drawer__empty-btn" data-cart-close>${escapeHtml(labels.continue)}</button>
      </div>`;
  }

  const itemsHtml = items
    .map((item, index) => {
      const line = index + 1;
      const imgUrl = item.featured_image?.url || item.image || '';
      const variantTitle = String(item.variant_title || '').replace(/ОС/g, 'XS');
      const showVariant = variantTitle && variantTitle !== 'Default Title';
      const productTitle = englishProductTitleFromCartItem(item);
      const itemUrl = item.url || '#';
      const linePrice = formatDrawerMoney(item.final_line_price, fmt);
      const qty = Number(item.quantity) || 0;

      const imgBlock = imgUrl
        ? `<img src="${escapeHtml(imgUrl)}" loading="lazy" alt="${escapeHtml(productTitle)}">`
        : `<span class="placeholder-svg" aria-hidden="true"></span>`;

      return `
      <li class="cart-drawer__item" data-line="${line}" data-quantity="${qty}">
        <a href="${escapeHtml(itemUrl)}" class="cart-drawer__item-media">${imgBlock}</a>
        <div class="cart-drawer__item-main">
          <div class="cart-drawer__item-top">
            <a href="${escapeHtml(itemUrl)}" class="cart-drawer__item-title">${escapeHtml(productTitle)}</a>
            <button type="button" class="cart-drawer__remove" data-cart-remove aria-label="${escapeHtml(labels.remove)}">${CART_DRAWER_REMOVE_ICON}</button>
          </div>
          ${showVariant ? `<p class="cart-drawer__item-variant">${escapeHtml(variantTitle)}</p>` : ''}
          <p class="cart-drawer__item-price">${linePrice}</p>
          <div class="cart-drawer__qty">
            <button type="button" class="cart-drawer__qty-btn" data-cart-minus aria-label="${escapeHtml(labels.decreaseQty)}">-</button>
            <span data-cart-qty-label>${qty}</span>
            <button type="button" class="cart-drawer__qty-btn" data-cart-plus aria-label="${escapeHtml(labels.increaseQty)}">+</button>
          </div>
        </div>
      </li>`;
    })
    .join('');

  const needMore = Math.max(0, threshold - totalPrice);
  const needMoreFormatted = formatDrawerMoney(needMore, fmt);
  let hintHtml = '';
  if (shippingCost > 0 && labels.freeShippingHintTemplate) {
    const hintText = String(labels.freeShippingHintTemplate)
      .replace(/__AMOUNT__/g, needMoreFormatted)
      .replace(/%AMOUNT%/g, needMoreFormatted);
    hintHtml = `<p>${escapeHtml(hintText)}</p>`;
  }

  const shippingDisplay =
    shippingCost === 0 ? escapeHtml(labels.shippingFree) : formatDrawerMoney(shippingCost, fmt);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const fallbackCheckout = `${String(root).replace(/\/?$/, '/') }checkout`;
  const checkoutUrl = cfg.checkoutUrl || fallbackCheckout;
  const cartUrl = cfg.cartUrl || '/cart';

  let paymeBtnHtml = '';
  if (cfg.payme?.show) {
    paymeBtnHtml = `<button type="button" class="button cart-drawer__payme" data-payme-checkout data-payme-loading-text="${escapeHtml(cfg.payme.loading || '')}">${escapeHtml(cfg.payme.checkout || '')}</button>`;
  }

  return `
    <div class="cart-drawer__body">
      <ul class="cart-drawer__items">${itemsHtml}</ul>
    </div>
    <div class="cart-drawer__footer">
      <div class="cart-drawer__summary">
        <div><span>${escapeHtml(labels.subtotal)}</span><span>${formatDrawerMoney(totalPrice, fmt)}</span></div>
        <div><span>${escapeHtml(labels.shipping)}</span><span>${shippingDisplay}</span></div>
        ${hintHtml}
      </div>
      <div class="cart-drawer__total">
        <span>${escapeHtml(labels.total)}</span>
        <span>${formatDrawerMoney(totalWithShipping, fmt)}</span>
      </div>
      <a href="${escapeHtml(checkoutUrl)}" class="button cart-drawer__checkout">${escapeHtml(labels.checkout)}</a>
      ${paymeBtnHtml}
      <a href="${escapeHtml(cartUrl)}" class="button cart-drawer__viewcart">${escapeHtml(labels.viewCart)}</a>
      <button type="button" class="cart-drawer__continue" data-cart-close>${escapeHtml(labels.continue)}</button>
    </div>`;
}

async function refreshCartDrawer(existingCart) {
  const drawer = document.querySelector('[data-cart-drawer]');
  const mount = document.querySelector('[data-cart-drawer-dynamic]');
  const cfg = getCartDrawerConfig();
  if (!drawer || !mount || !cfg) return;

  let cart = existingCart;
  if (!cart) {
    try {
      const cartRes = await fetch('/cart.js');
      if (!cartRes.ok) return;
      cart = await cartRes.json();
    } catch {
      return;
    }
  }

  document.querySelectorAll('.cart-badge').forEach((el) => {
    el.textContent = String(cart.item_count);
  });

  const titleTpl = cfg.titleTemplate || '';
  const headerH2 = drawer.querySelector('.cart-drawer__header h2');
  if (headerH2 && titleTpl) {
    headerH2.textContent = titleTpl.replace(/__COUNT__/g, String(cart.item_count));
  }

  mount.innerHTML = buildCartDrawerDynamicHtml(cart, cfg);
}

window.refreshCartDrawer = refreshCartDrawer;

function setCartDrawerState(open) {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  if (open) {
    setSearchOverlayState(false);
  }
  drawer.setAttribute('data-open', String(open));
  drawer.setAttribute('aria-hidden', String(!open));
  document.body.classList.toggle('cart-open', open);
}

const SEARCH_LS_KEY = 'aije_recent_searches';
const RECENT_SESSIONS_KEY = 'aije_recent_search_sessions';
const MAX_RECENT_SEARCHES = 8;
const MAX_SESSIONS_STORED = 8;
const MAX_PRODUCTS_PER_SEARCH_SNAPSHOT = 8;

function getRecentSearches() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(SEARCH_LS_KEY) || '[]');
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch {
    return [];
  }
}

function getRecentSessions() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(RECENT_SESSIONS_KEY) || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function syncQueriesFromSessions(sessions) {
  const queries = sessions.map((s) => s.query).filter(Boolean).slice(0, MAX_RECENT_SEARCHES);
  window.localStorage.setItem(SEARCH_LS_KEY, JSON.stringify(queries));
}

function migrateLegacySessions() {
  if (getRecentSessions().length > 0) return;
  const old = getRecentSearches();
  if (!old.length) return;
  const sessions = old.map((q) => ({ query: String(q), products: [], ts: 0 }));
  window.localStorage.setItem(RECENT_SESSIONS_KEY, JSON.stringify(sessions.slice(0, MAX_SESSIONS_STORED)));
}

function saveRecentSearch(term) {
  const q = String(term || '').trim();
  if (!q) return;
  let sessions = getRecentSessions();
  const existing = sessions.find((s) => s.query.toLowerCase() === q.toLowerCase());
  sessions = sessions.filter((s) => s.query.toLowerCase() !== q.toLowerCase());
  sessions.unshift({
    query: q,
    products: existing?.products || [],
    ts: Date.now(),
  });
  sessions = sessions.slice(0, MAX_SESSIONS_STORED);
  window.localStorage.setItem(RECENT_SESSIONS_KEY, JSON.stringify(sessions));
  syncQueriesFromSessions(sessions);
}

function saveRecentSearchSnapshot(data) {
  const q = String(data?.query || '').trim();
  if (!q || !Array.isArray(data.products) || data.products.length === 0) return;
  let sessions = getRecentSessions();
  sessions = sessions.filter((s) => s.query.toLowerCase() !== q.toLowerCase());
  sessions.unshift({
    query: q,
    products: data.products.slice(0, MAX_PRODUCTS_PER_SEARCH_SNAPSHOT),
    ts: Date.now(),
  });
  sessions = sessions.slice(0, MAX_SESSIONS_STORED);
  window.localStorage.setItem(RECENT_SESSIONS_KEY, JSON.stringify(sessions));
  syncQueriesFromSessions(sessions);
}

window.saveRecentSearchSnapshot = saveRecentSearchSnapshot;

function syncSearchOverlayHeaderOffset() {
  const header = document.querySelector('.site-header');
  if (!header) {
    document.documentElement.style.setProperty('--search-overlay-padding-top', '4rem');
    document.documentElement.style.setProperty('--header-dropdown-top', '4rem');
    return;
  }
  let bottom = header.getBoundingClientRect().bottom;
  if (!document.body.classList.contains('search-open')) {
    const announcement = document.querySelector('.announcement-wrap');
    if (announcement && !announcement.classList.contains('is-hidden')) {
      bottom = Math.max(bottom, announcement.getBoundingClientRect().bottom);
    }
  }
  const px = Math.max(1, Math.round(bottom));
  document.documentElement.style.setProperty('--search-overlay-padding-top', `${px}px`);
  document.documentElement.style.setProperty('--header-dropdown-top', `${px}px`);
}

let searchHeaderResizeObserver = null;

function detachSearchHeaderResizeObserver() {
  if (searchHeaderResizeObserver) {
    searchHeaderResizeObserver.disconnect();
    searchHeaderResizeObserver = null;
  }
}

function attachSearchHeaderResizeObserver() {
  detachSearchHeaderResizeObserver();
  const header = document.querySelector('.site-header');
  if (!header || typeof ResizeObserver === 'undefined') return;
  searchHeaderResizeObserver = new ResizeObserver(() => {
    if (document.body.classList.contains('search-open')) {
      syncSearchOverlayHeaderOffset();
    }
  });
  searchHeaderResizeObserver.observe(header);
}

function submitOverlaySearch(overlay, query) {
  const input = overlay.querySelector('[data-search-input]');
  const form = overlay.querySelector('[data-search-form]');
  if (input && form) {
    input.value = query;
    saveRecentSearch(query);
    form.submit();
  }
}

function renderRecentSearchHistory(overlay) {
  migrateLegacySessions();
  const section = overlay.querySelector('[data-recent-searches-section]');
  const pillsRoot = overlay.querySelector('[data-recent-sessions-root]');
  if (!section || !pillsRoot) return;

  const sessions = getRecentSessions().filter((s) => String(s.query || '').trim());
  pillsRoot.innerHTML = '';

  if (sessions.length === 0) {
    section.hidden = true;
    section.setAttribute('aria-hidden', 'true');
    return;
  }

  section.hidden = false;
  section.removeAttribute('hidden');
  section.setAttribute('aria-hidden', 'false');

  sessions.slice(0, MAX_SESSIONS_STORED).forEach((session) => {
    const pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'search-overlay__pill search-overlay__pill--recent';
    pill.textContent = session.query;
    pill.addEventListener('click', () => submitOverlaySearch(overlay, session.query));
    pillsRoot.appendChild(pill);
  });
}

function getMenuAriaLabels() {
  const d = document.body?.dataset || {};
  return {
    open: d.menuAriaOpen || 'Open menu',
    close: d.menuAriaClose || 'Close menu',
  };
}

const NAV_DROPDOWN_CLOSE_MS = 450;

function closeAllNavDropdowns() {
  document.querySelectorAll('[data-nav-dropdown].is-open').forEach((item) => {
    const trigger = item.querySelector('[data-nav-dropdown-trigger]');
    const panel = item.querySelector('[data-nav-dropdown-panel]');
    item.classList.remove('is-open');
    trigger?.setAttribute('aria-expanded', 'false');
    if (panel) {
      window.setTimeout(() => {
        if (!item.classList.contains('is-open')) panel.hidden = true;
      }, NAV_DROPDOWN_CLOSE_MS);
    }
  });

  document.querySelectorAll('[data-mobile-submenu].is-open').forEach((item) => {
    const toggle = item.querySelector('[data-mobile-submenu-toggle]');
    const panel = item.querySelector('[data-mobile-submenu-panel]');
    item.classList.remove('is-open');
    toggle?.setAttribute('aria-expanded', 'false');
    if (panel) {
      window.setTimeout(() => {
        if (!item.classList.contains('is-open')) panel.hidden = true;
      }, NAV_DROPDOWN_CLOSE_MS);
    }
  });

  document.querySelector('.site-header')?.classList.remove('nav-dropdown-open');
}

function openNavDropdown(item) {
  closeAllNavDropdowns();
  const trigger = item.querySelector('[data-nav-dropdown-trigger]');
  const panel = item.querySelector('[data-nav-dropdown-panel]');
  if (!trigger || !panel) return;

  syncSearchOverlayHeaderOffset();
  panel.hidden = false;
  window.requestAnimationFrame(() => {
    void panel.offsetHeight;
    window.requestAnimationFrame(() => {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.querySelector('.site-header')?.classList.add('nav-dropdown-open');
      syncSearchOverlayHeaderOffset();
    });
  });
}

function setMobileSubmenuOpen(item, open) {
  const toggle = item.querySelector('[data-mobile-submenu-toggle]');
  const panel = item.querySelector('[data-mobile-submenu-panel]');
  if (!toggle || !panel) return;

  if (open) {
    panel.hidden = false;
    window.requestAnimationFrame(() => {
      void panel.offsetHeight;
      window.requestAnimationFrame(() => {
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      });
    });
    return;
  }

  item.classList.remove('is-open');
  toggle.setAttribute('aria-expanded', 'false');
  window.setTimeout(() => {
    if (!item.classList.contains('is-open')) panel.hidden = true;
  }, NAV_DROPDOWN_CLOSE_MS);
}

function initHeaderNavDropdowns() {
  document.querySelectorAll('[data-nav-dropdown]:not([data-nav-dropdown-init])').forEach((item) => {
    const trigger = item.querySelector('[data-nav-dropdown-trigger]');
    const panel = item.querySelector('[data-nav-dropdown-panel]');
    if (!trigger || !panel) return;

    item.setAttribute('data-nav-dropdown-init', 'true');

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (item.classList.contains('is-open')) {
        closeAllNavDropdowns();
      } else {
        openNavDropdown(item);
      }
    });
  });
}

function closeFooterLangDropdowns() {
  document.querySelectorAll('[data-footer-lang-dropdown].is-open').forEach((dropdown) => {
    dropdown.classList.remove('is-open');
    dropdown.querySelector('[data-footer-lang-trigger]')?.setAttribute('aria-expanded', 'false');
    dropdown.querySelector('[data-footer-lang-list]')?.setAttribute('hidden', '');
  });
}

function initFooterLangDropdowns() {
  document.querySelectorAll('[data-footer-lang-dropdown]:not([data-footer-lang-init])').forEach((dropdown) => {
    const trigger = dropdown.querySelector('[data-footer-lang-trigger]');
    const list = dropdown.querySelector('[data-footer-lang-list]');
    const form = dropdown.querySelector('.site-footer__lang-form');
    const input = dropdown.querySelector('[data-footer-lang-input]');
    if (!trigger || !list || !form || !input) return;

    dropdown.setAttribute('data-footer-lang-init', 'true');

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const isOpen = dropdown.classList.contains('is-open');
      closeFooterLangDropdowns();
      if (!isOpen) {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        list.removeAttribute('hidden');
      }
    });

    list.querySelectorAll('[data-footer-lang-option]').forEach((option) => {
      option.addEventListener('click', (event) => {
        event.preventDefault();
        const code = option.getAttribute('data-locale-code');
        if (!code || code === input.value) {
          closeFooterLangDropdowns();
          return;
        }
        input.value = code;
        form.submit();
      });
    });
  });
}

function setSearchOverlayState(open) {
  const overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;
  overlay.setAttribute('data-open', String(open));
  overlay.setAttribute('aria-hidden', String(!open));
  document.body.classList.toggle('search-open', open);
  if (open) {
    closeAllNavDropdowns();
    setCartDrawerState(false);
    const menu = document.querySelector('[data-mobile-menu]');
    const toggle = document.querySelector('[data-mobile-menu-toggle]');
    const header = document.querySelector('.site-header');
    if (menu && menu.getAttribute('data-open') === 'true') {
      menu.setAttribute('data-open', 'false');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', getMenuAriaLabels().open);
      }
      header?.classList.remove('menu-open');
    }
    syncHomeHeaderState();
    renderRecentSearchHistory(overlay);
    attachSearchHeaderResizeObserver();
    const input = overlay.querySelector('[data-search-input]');
    const bumpSync = () => syncSearchOverlayHeaderOffset();
    bumpSync();
    window.requestAnimationFrame(() => {
      bumpSync();
      window.requestAnimationFrame(() => {
        bumpSync();
        window.setTimeout(bumpSync, 0);
        window.setTimeout(bumpSync, 120);
        input?.focus();
      });
    });
  } else {
    detachSearchHeaderResizeObserver();
  }
}

function initSearchOverlay() {
  const overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;

  syncSearchOverlayHeaderOffset();

  const form = overlay.querySelector('[data-search-form]');
  const input = overlay.querySelector('[data-search-input]');
  if (form && input) {
    form.addEventListener('submit', () => {
      const q = input.value.trim();
      if (q) saveRecentSearch(q);
    });
  }

  renderRecentSearchHistory(overlay);
}

function setSizeGuidePageLock(locked) {
  if (locked) {
    const scrollbar = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    document.body.classList.add('size-guide-open');
    document.body.style.paddingRight = scrollbar > 0 ? `${scrollbar}px` : '';
    return;
  }
  document.body.classList.remove('size-guide-open');
  document.body.style.paddingRight = '';
}

function getSizeGuideRoot() {
  return document.querySelector('[data-size-guide]');
}

function openSizeGuide() {
  const sizeGuide = getSizeGuideRoot();
  if (!sizeGuide) return;
  if (sizeGuide.parentElement !== document.body) {
    document.body.appendChild(sizeGuide);
  }
  sizeGuide.setAttribute('data-open', 'true');
  sizeGuide.setAttribute('aria-hidden', 'false');
  setSizeGuidePageLock(true);
}

function closeSizeGuide() {
  const sizeGuide = getSizeGuideRoot();
  if (!sizeGuide) return;
  sizeGuide.setAttribute('data-open', 'false');
  sizeGuide.setAttribute('aria-hidden', 'true');
  setSizeGuidePageLock(false);
}

function initSizeGuide() {
  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-size-guide-open]');
    if (openBtn) {
      event.preventDefault();
      openSizeGuide();
      return;
    }
    const closeBtn = event.target.closest('[data-size-guide-close]');
    if (closeBtn) {
      event.preventDefault();
      closeSizeGuide();
    }
  });
}

function initProductPage() {
  document.querySelectorAll('[data-product-page]').forEach((page) => {
    const form = page.querySelector('[data-product-main-form]');
    const variantInput = page.querySelector('[data-product-variant-id]');
    const variantsJson = page.querySelector('[data-product-variants]');
    let variants = [];
    try {
      variants = JSON.parse(variantsJson?.textContent || '[]');
    } catch {
      variants = [];
    }
    const colorPos = Number(form?.getAttribute('data-color-option-position') || 0);
    const sizePos = Number(form?.getAttribute('data-size-option-position') || 0);
    const colorIndex = colorPos > 0 ? colorPos - 1 : -1;
    const sizeIndex = sizePos > 0 ? sizePos - 1 : -1;
    const preorderEnabled =
      page.getAttribute('data-preorder-enabled') === 'true' ||
      form?.getAttribute('data-preorder-enabled') === 'true';

    const qtyInput = page.querySelector('[data-product-qty-input]');
    const addBtn = page.querySelector('[data-add-text]');
    const priceEl = page.querySelector('.product-page__price');
    const moneyNode = page.querySelector('[data-money-format]');
    let moneyFmt = '{{amount}}';
    try {
      if (moneyNode) moneyFmt = JSON.parse(moneyNode.textContent || '"{{amount}}"');
    } catch {
      moneyFmt = '{{amount}}';
    }
    const unitPrice = Number(addBtn?.getAttribute('data-unit-price') || 0);

    const getActiveValue = (selector, attr) => {
      const active = page.querySelector(`${selector}.is-active`);
      return active ? active.getAttribute(attr) : null;
    };

    const findMatchedVariant = () => {
      if (!Array.isArray(variants) || variants.length === 0) return null;
      const selectedColor = getActiveValue('[data-color-value]', 'data-color-value');
      const selectedSize = getActiveValue('[data-size-value]', 'data-size-value');
      const requireAvailable = !preorderEnabled;
      const matched = variants.find((variant) => {
        if (requireAvailable && !variant?.available) return false;
        const opts = variant.options || [variant.option1, variant.option2, variant.option3];
        const colorByPos = colorIndex >= 0 && opts[colorIndex] === selectedColor;
        const sizeByPos = sizeIndex >= 0 && opts[sizeIndex] === selectedSize;
        const colorByValue = selectedColor ? opts.includes(selectedColor) : true;
        const sizeByValue = selectedSize ? opts.includes(selectedSize) : true;
        const colorOk = !selectedColor || (colorIndex >= 0 ? colorByPos : colorByValue);
        const sizeOk = !selectedSize || (sizeIndex >= 0 ? sizeByPos : sizeByValue);
        return colorOk && sizeOk;
      });
      if (matched) return matched;
      if (preorderEnabled) return variants[0];
      return variants.find((v) => v?.available) || variants[0];
    };

    const isPreorderVariant = (variant) => {
      if (!preorderEnabled || !variant) return false;
      if (variant.available === false) return true;
      const qty = Number(variant.inventory_quantity);
      if (variant.inventory_management && Number.isFinite(qty) && qty <= 0) return true;
      return false;
    };

    const syncPreorderProperty = (variant) => {
      if (!form) return;
      let prop = form.querySelector('[data-preorder-property]');
      if (isPreorderVariant(variant)) {
        if (!prop) {
          prop = document.createElement('input');
          prop.type = 'hidden';
          prop.name = 'properties[Pre-order]';
          prop.setAttribute('data-preorder-property', '');
          form.appendChild(prop);
        }
        prop.value = 'Yes';
      } else if (prop) {
        prop.remove();
      }
    };

    const updateDisplayedPrice = () => {
      const matched = findMatchedVariant();
      const unitCents = matched ? Number(matched.price || 0) : Number(addBtn?.getAttribute('data-unit-price') || unitPrice || 0);
      const qty = Math.max(1, Number(qtyInput?.value || 1));
      const totalCents = unitCents * qty;
      const formatted = wishlistApplyMoneyTemplate(totalCents, moneyFmt);
      const preorder = isPreorderVariant(matched);

      if (variantInput && matched?.id) {
        variantInput.value = String(matched.id);
      }
      syncPreorderProperty(matched);
      if (addBtn) {
        addBtn.setAttribute('data-unit-price', String(unitCents));
        const priceTpl = addBtn.getAttribute('data-add-price-template') || '';
        const preorderTpl = addBtn.getAttribute('data-preorder-price-template') || '';
        const soldOutText = addBtn.getAttribute('data-sold-out-text') || '';
        if (preorder && preorderTpl) {
          addBtn.textContent = preorderTpl.split('%PRICE%').join(formatted);
          addBtn.disabled = true;
        } else if (!matched?.available && !preorderEnabled && soldOutText) {
          addBtn.textContent = soldOutText;
          addBtn.disabled = true;
        } else {
          addBtn.textContent = priceTpl ? priceTpl.split('%PRICE%').join(formatted) : formatted;
          addBtn.disabled = preorderEnabled ? true : !matched?.available;
        }
      }
      if (priceEl) {
        priceEl.textContent = formatted;
      }
    };

    const syncSelectedVariant = () => {
      updateDisplayedPrice();
      applyColorGallery(getActiveValue('[data-color-value]', 'data-color-value'));
    };

    let mediaByColor = {};
    try {
      const mediaNode = page.querySelector('[data-product-media-by-color]');
      mediaByColor = JSON.parse(mediaNode?.textContent || '{}');
    } catch {
      mediaByColor = {};
    }

    const normalizeColorKey = (value) => String(value || '').trim().toLowerCase();

    const fileBasename = (url) => {
      if (!url) return '';
      const clean = String(url).split('?')[0];
      const parts = clean.split('/');
      return (parts[parts.length - 1] || '').toLowerCase();
    };

    const filesByColor = {};
    page.querySelectorAll('[data-color-value]').forEach((btn) => {
      const color = btn.getAttribute('data-color-value');
      const file = (btn.getAttribute('data-color-image-file') || '').toLowerCase();
      if (!color) return;
      if (!filesByColor[color]) filesByColor[color] = new Set();
      if (file) filesByColor[color].add(file);
    });
    // Prefer storefront product.js — image IDs in Liquid can differ from gallery IDs
    const productHandle =
      page.getAttribute('data-product-handle') ||
      (document.querySelector('link[rel="canonical"]')?.href || '').split('/products/')[1]?.split(/[?#]/)[0] ||
      '';
    const hydrateFromProductJs = async () => {
      if (!productHandle) return;
      try {
        const res = await fetch(`/products/${productHandle}.js`);
        if (!res.ok) return;
        const product = await res.json();
        const optionNames = (product.options || []).map((o) => (typeof o === 'string' ? o : o?.name || ''));
        const colorOptIdx = optionNames.findIndex((n) => /color|colour|цвет/i.test(String(n)));
        (product.variants || []).forEach((variant) => {
          const opts = variant.options || [variant.option1, variant.option2, variant.option3];
          const color = colorOptIdx >= 0 ? opts[colorOptIdx] : null;
          if (!color) return;
          if (!filesByColor[color]) filesByColor[color] = new Set();
          const src = variant.featured_image?.src || '';
          const file = fileBasename(src);
          if (file) filesByColor[color].add(file);
        });
        applyColorGallery(getActiveValue('[data-color-value]', 'data-color-value'));
      } catch {
        /* ignore */
      }
    };
    hydrateFromProductJs();

    const mediaIdsForColor = (color) => {
      if (!color) return [];
      const files = filesByColor[color] || filesByColor[Object.keys(filesByColor).find((k) => normalizeColorKey(k) === normalizeColorKey(color))] || new Set();
      if (!files.size) return [];
      return Array.from(page.querySelectorAll('[data-gallery-item]'))
        .filter((el) => files.has((el.getAttribute('data-image-file') || '').toLowerCase()))
        .map((el) => String(el.getAttribute('data-media-id') || ''))
        .filter(Boolean);
    };

    const applyColorGallery = (color) => {
      const items = Array.from(page.querySelectorAll('[data-gallery-item]'));
      if (!items.length) return;
      const colorNorm = normalizeColorKey(color);
      const files =
        filesByColor[color] ||
        filesByColor[Object.keys(filesByColor).find((k) => normalizeColorKey(k) === normalizeColorKey(color))] ||
        new Set();
      const preferredIds = new Set(mediaIdsForColor(color));
      let anyMatch = false;

      items.forEach((item) => {
        const mediaId = String(item.getAttribute('data-media-id') || '');
        const file = (item.getAttribute('data-image-file') || '').toLowerCase();
        const match = (files.size > 0 && files.has(file)) || preferredIds.has(mediaId);
        if (match) anyMatch = true;
        item.classList.toggle('is-color-match', Boolean(match));
      });

      if (anyMatch) {
        items.forEach((item) => {
          const hide = !item.classList.contains('is-color-match');
          item.classList.toggle('is-color-hidden', hide);
          item.hidden = hide;
        });
      } else {
        items.forEach((item) => {
          item.classList.remove('is-color-hidden', 'is-color-match');
          item.hidden = false;
        });
      }

      const visibleItems = items.filter((item) => !item.hidden);
      const dots = Array.from(page.querySelectorAll('[data-gallery-dot]'));
      if (dots.length) {
        dots.forEach((dot) => {
          const id = String(dot.getAttribute('data-media-id') || '');
          const show = !anyMatch || !id || visibleItems.some((item) => String(item.getAttribute('data-media-id') || '') === id);
          dot.hidden = !show;
          dot.classList.toggle('is-active', false);
        });
        const firstVisible = visibleItems[0];
        const firstId = firstVisible ? String(firstVisible.getAttribute('data-media-id') || '') : '';
        const activeDot =
          dots.find((dot) => !dot.hidden && String(dot.getAttribute('data-media-id') || '') === firstId) ||
          dots.find((dot) => !dot.hidden);
        activeDot?.classList.add('is-active');
      }

      const track = page.querySelector('[data-mobile-gallery-track]');
      const firstVisibleMobile = visibleItems.find((item) => item.closest('[data-mobile-gallery-track]'));
      if (track && firstVisibleMobile) {
        track.scrollTo({ left: firstVisibleMobile.offsetLeft, behavior: 'smooth' });
      }
    };

    const galleryTrack = page.querySelector('[data-mobile-gallery-track]');
    const dots = Array.from(page.querySelectorAll('.product-page__mobile-dot'));
    if (galleryTrack && dots.length > 0) {
      galleryTrack.addEventListener('scroll', () => {
        const visibleSlides = Array.from(galleryTrack.querySelectorAll('[data-gallery-item]')).filter((el) => !el.hidden);
        const width = galleryTrack.clientWidth || 1;
        const index = Math.max(0, Math.min(visibleSlides.length - 1, Math.round(galleryTrack.scrollLeft / width)));
        const activeSlide = visibleSlides[index];
        const activeId = activeSlide ? String(activeSlide.getAttribute('data-media-id') || '') : '';
        dots.forEach((dot) => {
          if (dot.hidden) {
            dot.classList.remove('is-active');
            return;
          }
          const id = String(dot.getAttribute('data-media-id') || '');
          dot.classList.toggle('is-active', Boolean(activeId) && id === activeId);
        });
      });
    }

    const canHoverZoom = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (canHoverZoom) {
      page.querySelectorAll('.product-page__desktop-cell').forEach((cell) => {
        const img = cell.querySelector('img.product-page__gallery-img') || cell.querySelector('img');
        if (!img) return;

        const lens = document.createElement('div');
        lens.className = 'product-page__zoom-lens';
        cell.appendChild(lens);
        const zoom = 2.2;

        const zoomBackgroundSrc = () => {
          const raw = (img.currentSrc || img.src || '').trim();
          if (!raw || raw.startsWith('data:')) return '';
          return raw.replace(/"/g, '\\"');
        };

        const renderZoom = (event) => {
          const safeSrc = zoomBackgroundSrc();
          if (!safeSrc) return;
          const rect = cell.getBoundingClientRect();
          const lensSize = lens.offsetWidth || 180;
          const half = lensSize / 2;
          const x = Math.max(0, Math.min(rect.width, event.clientX - rect.left));
          const y = Math.max(0, Math.min(rect.height, event.clientY - rect.top));
          const lensX = Math.max(0, Math.min(rect.width - lensSize, x - half));
          const lensY = Math.max(0, Math.min(rect.height - lensSize, y - half));

          lens.style.transform = `translate(${lensX}px, ${lensY}px)`;
          lens.style.backgroundImage = `url("${safeSrc}")`;
          lens.style.backgroundSize = `${rect.width * zoom}px ${rect.height * zoom}px`;
          lens.style.backgroundPosition = `${-(x * zoom - half)}px ${-(y * zoom - half)}px`;
        };

        cell.addEventListener('mouseenter', (event) => {
          lens.classList.add('is-active');
          renderZoom(event);
        });
        cell.addEventListener('mousemove', renderZoom);
        cell.addEventListener('mouseleave', () => {
          lens.classList.remove('is-active');
        });
      });
    }

    const colorLabel = page.querySelector('[data-color-label]');
    page.querySelectorAll('[data-color-value]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        page.querySelectorAll('[data-color-value]').forEach((x) => x.classList.remove('is-active'));
        btn.classList.add('is-active');
        if (colorLabel) {
          colorLabel.textContent =
            btn.getAttribute('data-color-display') || btn.getAttribute('data-color-value') || '';
        }
        syncSelectedVariant();
      });
    });

    page.querySelectorAll('[data-size-value]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        page.querySelectorAll('[data-size-value]').forEach((x) => x.classList.remove('is-active'));
        btn.classList.add('is-active');
        syncSelectedVariant();
      });
    });

    const qtyLabel = page.querySelector('[data-product-qty-label]');
    const syncQty = (qty) => {
      const safeQty = Math.max(1, Number(qty) || 1);
      if (qtyInput) qtyInput.value = String(safeQty);
      if (qtyLabel) qtyLabel.textContent = String(safeQty);
      updateDisplayedPrice();
      return safeQty;
    };

    syncQty(Number(qtyInput?.value || 1));
    applyColorGallery(getActiveValue('[data-color-value]', 'data-color-value'));

    const minus = page.querySelector('[data-product-qty-minus]');
    const plus = page.querySelector('[data-product-qty-plus]');
    minus?.addEventListener('click', () => syncQty(Number(qtyInput?.value || 1) - 1));
    plus?.addEventListener('click', () => syncQty(Number(qtyInput?.value || 1) + 1));

    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      syncSelectedVariant();
      if (qtyInput) {
        qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1)));
      }

      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) {
          form.submit();
          return;
        }

        const cartRes = await fetch('/cart.js');
        if (cartRes.ok) {
          const cart = await cartRes.json();
          await refreshCartDrawer(cart);
        } else {
          await refreshCartDrawer();
        }
        setCartDrawerState(true);
      } catch {
        form.submit();
      }
    });

    const accordion = page.querySelector('[data-product-accordion]');
    const accTransitionMs = 360;

    const setAccordionPanel = (panel, open) => {
      if (!panel) return;
      if (open) {
        panel.removeAttribute('hidden');
        panel.getBoundingClientRect();
        panel.classList.add('is-open');
        return;
      }
      panel.classList.remove('is-open');
      window.setTimeout(() => {
        if (!panel.classList.contains('is-open')) {
          panel.setAttribute('hidden', '');
        }
      }, accTransitionMs);
    };

    const closeAllAccordionPanels = (exceptKey = null) => {
      if (!accordion) return;
      accordion.querySelectorAll('[data-acc-panel]').forEach((p) => {
        if (exceptKey && p.getAttribute('data-acc-panel') === exceptKey) return;
        setAccordionPanel(p, false);
      });
      accordion.querySelectorAll('[data-acc-toggle]').forEach((b) => {
        if (exceptKey && b.getAttribute('data-acc-toggle') === exceptKey) return;
        b.classList.remove('is-open');
        b.setAttribute('aria-expanded', 'false');
      });
    };

    accordion?.querySelectorAll('[data-acc-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.getAttribute('data-acc-toggle');
        if (!key) return;
        const panel = accordion.querySelector(`[data-acc-panel="${key}"]`);
        if (!panel) return;
        const willOpen = !panel.classList.contains('is-open');
        if (willOpen) {
          closeAllAccordionPanels(key);
          setAccordionPanel(panel, true);
          btn.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        } else {
          closeAllAccordionPanels();
        }
      });
    });

    syncSelectedVariant();
  });
}

const WISHLIST_LS_KEY = 'aije_wishlist_handles';
const MAX_WISHLIST_ITEMS = 200;
const COOKIE_CONSENT_LS_KEY = 'aije_cookie_consent_accepted';
const COOKIE_PREFS_LS_KEY = 'aije_cookie_preferences';

function getWishlistHandles() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(WISHLIST_LS_KEY) || '[]');
    return Array.isArray(parsed) ? parsed.map((h) => String(h || '').trim()).filter(Boolean) : [];
  } catch {
    return [];
  }
}

function saveWishlistHandles(handles) {
  const unique = [];
  const seen = new Set();
  handles.forEach((h) => {
    const key = String(h || '').trim().toLowerCase();
    if (!key || seen.has(key)) return;
    seen.add(key);
    unique.push(String(h).trim());
  });
  try {
    window.localStorage.setItem(WISHLIST_LS_KEY, JSON.stringify(unique.slice(0, MAX_WISHLIST_ITEMS)));
  } catch {
    /* blocked storage / quota */
  }
}

function wishlistContains(handle) {
  const h = String(handle || '').trim().toLowerCase();
  if (!h) return false;
  return getWishlistHandles().some((x) => x.toLowerCase() === h);
}

function toggleWishlistProduct(handle) {
  const raw = String(handle || '').trim();
  if (!raw) return false;
  const list = getWishlistHandles();
  const idx = list.findIndex((x) => x.toLowerCase() === raw.toLowerCase());
  if (idx >= 0) {
    list.splice(idx, 1);
    saveWishlistHandles(list);
    return false;
  }
  list.unshift(raw);
  saveWishlistHandles(list);
  return true;
}

function syncWishlistHeaderCount() {
  const n = getWishlistHandles().length;
  document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
    el.textContent = String(n);
    if (n === 0) {
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
    } else {
      el.removeAttribute('hidden');
      el.setAttribute('aria-hidden', 'false');
    }
  });
}

function syncWishlistButtons() {
  document.querySelectorAll('[data-wishlist-toggle][data-product-handle]').forEach((btn) => {
    const handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    const on = wishlistContains(handle);
    btn.classList.toggle('product-card__wishlist--active', on);
    if (btn.classList.contains('product-page__wish')) {
      btn.classList.toggle('is-active', on);
    }
    btn.setAttribute('aria-pressed', String(on));
    const addLab = btn.getAttribute('data-wishlist-label-add');
    const remLab = btn.getAttribute('data-wishlist-label-remove');
    if (addLab && remLab) {
      btn.setAttribute('aria-label', on ? remLab : addLab);
      if (btn.classList.contains('product-page__wish')) {
        btn.textContent = on ? remLab : addLab;
      }
    }
  });
  syncWishlistHeaderCount();
}

function wishlistMoneyFromProduct(product) {
  if (product.price_min != null) return Number(product.price_min);
  if (product.price != null) return Number(product.price);
  const v = product.variants && product.variants[0];
  if (v && v.price != null) return Number(v.price);
  return 0;
}

function wishlistApplyMoneyTemplate(cents, template) {
  const c = Number(cents);
  if (Number.isNaN(c)) return '';
  const amount = (c / 100).toFixed(2);
  const noDec = String(Math.round(c / 100));
  let t = typeof template === 'string' ? template : '{{amount}}';
  return t
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, noDec)
    .replace(/\{\{\s*amount\s*\}\}/gi, amount);
}

function storefrontLocaleRoot() {
  const root = window.Shopify?.routes?.root;
  if (typeof root === 'string' && root.length) {
    return root.endsWith('/') ? root : `${root}/`;
  }
  const path = window.location.pathname || '/';
  const m = path.match(/^\/([a-z]{2}(?:-[a-z]{2})?)\//i);
  if (m && m[1].toLowerCase() !== 'cdn') {
    return `/${m[1]}/`;
  }
  return '/';
}

function localizedStorefrontPath(path) {
  const clean = String(path || '').trim();
  if (!clean) return storefrontLocaleRoot();
  if (/^https?:\/\//i.test(clean)) {
    try {
      const u = new URL(clean, window.location.origin);
      if (u.origin === window.location.origin) {
        return localizedStorefrontPath(u.pathname + u.search + u.hash);
      }
    } catch {
      /* ignore */
    }
    return clean;
  }
  const withSlash = clean.startsWith('/') ? clean : `/${clean}`;
  if (/^\/[a-z]{2}(?:-[a-z]{2})?\//i.test(withSlash)) return withSlash;
  const root = storefrontLocaleRoot();
  if (root === '/') return withSlash;
  return `${root.replace(/\/$/, '')}${withSlash}`;
}

async function fetchWishlistProductJson(handle) {
  const h = encodeURIComponent(handle);
  try {
    // Default-locale JSON keeps product titles English on RU/UZ storefronts.
    const res = await fetch(`/products/${h}.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

function buildWishlistPageCard(product, moneyTemplate) {
  const article = document.createElement('article');
  article.className = 'wishlist-page__card';

  const link = document.createElement('a');
  link.className = 'wishlist-page__card-link';
  const rawUrl = product.url || `/products/${encodeURIComponent(product.handle)}`;
  link.href = localizedStorefrontPath(rawUrl);

  const figure = document.createElement('div');
  figure.className = 'wishlist-page__card-media';
  let imgUrl = '';
  if (typeof product.featured_image === 'string') {
    imgUrl = product.featured_image;
  } else if (product.featured_image && typeof product.featured_image === 'object' && product.featured_image.src) {
    imgUrl = product.featured_image.src;
  }
  if (imgUrl) {
    const img = document.createElement('img');
    img.src = imgUrl;
    img.alt = product.title || '';
    img.loading = 'lazy';
    figure.appendChild(img);
  }

  const meta = document.createElement('div');
  meta.className = 'wishlist-page__card-meta';

  const title = document.createElement('h2');
  title.className = 'wishlist-page__card-title';
  title.textContent = product.title || '';

  const priceEl = document.createElement('p');
  priceEl.className = 'wishlist-page__card-price';
  priceEl.textContent = wishlistApplyMoneyTemplate(wishlistMoneyFromProduct(product), moneyTemplate);

  meta.append(title, priceEl);
  link.append(figure, meta);
  article.appendChild(link);
  return article;
}

async function refreshWishlistPageFromStorage() {
  const roots = document.querySelectorAll('[data-wishlist-page-root]');
  if (!roots.length) return;

  let moneyTemplate = '{{amount}}';
  const fmtEl = document.querySelector('[data-wishlist-money-format]');
  if (fmtEl) {
    try {
      moneyTemplate = JSON.parse(fmtEl.textContent || '"{{amount}}"');
    } catch {
      moneyTemplate = '{{amount}}';
    }
  }

  const handles = getWishlistHandles();
  roots.forEach((root) => {
    root.innerHTML = '';
  });

  const emptyEls = document.querySelectorAll('[data-wishlist-empty-msg]');
  if (handles.length === 0) {
    emptyEls.forEach((el) => {
      el.hidden = false;
    });
    return;
  }
  emptyEls.forEach((el) => {
    el.hidden = true;
  });

  const rows = await Promise.all(handles.map((h) => fetchWishlistProductJson(h)));
  const products = rows.filter(Boolean);
  if (products.length === 0) {
    emptyEls.forEach((el) => {
      el.hidden = false;
    });
    return;
  }
  emptyEls.forEach((el) => {
    el.hidden = true;
  });
  roots.forEach((root) => {
    products.forEach((p) => {
      root.appendChild(buildWishlistPageCard(p, moneyTemplate));
    });
  });
}

function notifyWishlistUpdated() {
  syncWishlistButtons();
  void refreshWishlistPageFromStorage();
  window.dispatchEvent(new CustomEvent('aije:wishlist-changed'));
}

function initWishlist() {
  syncWishlistButtons();
}

function initWishlistPage() {
  void refreshWishlistPageFromStorage();
}

function initCookieConsent() {
  const banner = document.querySelector('[data-cookie-consent]');
  if (!banner) return;

  let accepted = false;
  try {
    accepted = window.localStorage.getItem(COOKIE_CONSENT_LS_KEY) === '1';
  } catch {
    accepted = false;
  }
  if (accepted) return;

  banner.hidden = false;
  const acceptBtn = banner.querySelector('[data-cookie-consent-accept]');
  const rejectBtn = banner.querySelector('[data-cookie-consent-reject]');
  const customizeBtn = banner.querySelector('[data-cookie-consent-customize]');
  const saveBtn = banner.querySelector('[data-cookie-consent-save]');
  const panel = banner.querySelector('[data-cookie-consent-panel]');
  const analyticsInput = banner.querySelector('[data-cookie-pref-analytics]');
  const marketingInput = banner.querySelector('[data-cookie-pref-marketing]');
  const personalizationInput = banner.querySelector('[data-cookie-pref-personalization]');

  const savePrefs = (prefs) => {
    try {
      window.localStorage.setItem(COOKIE_CONSENT_LS_KEY, '1');
      window.localStorage.setItem(COOKIE_PREFS_LS_KEY, JSON.stringify(prefs));
    } catch {
      /* ignore storage errors */
    }
    banner.hidden = true;
  };

  if (panel) {
    panel.hidden = true;
  }

  if (acceptBtn) {
    acceptBtn.addEventListener('click', () => {
      savePrefs({ necessary: true, analytics: true, marketing: true, personalization: true });
    });
  }

  if (rejectBtn) {
    rejectBtn.addEventListener('click', () => {
      savePrefs({ necessary: true, analytics: false, marketing: false, personalization: false });
    });
  }

  if (customizeBtn) {
    customizeBtn.addEventListener('click', () => {
      if (!panel) return;
      panel.removeAttribute('hidden');
      panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  }

  if (saveBtn) {
    saveBtn.addEventListener('click', () => {
      savePrefs({
        necessary: true,
        analytics: Boolean(analyticsInput?.checked),
        marketing: Boolean(marketingInput?.checked),
        personalization: Boolean(personalizationInput?.checked),
      });
    });
  }
}

function shouldSkipTextReveal(el) {
  if (!el || !(el instanceof Element)) return true;
  if (!el.textContent?.trim()) return true;
  if (el.closest('[data-no-reveal],[hidden],[aria-hidden="true"],.sr-only,.skip-link,.mobile-menu,.search-overlay,.cart-drawer,.cookie-consent,.product-card__overlay,.product-card__image-link,.header-nav__item--dropdown,.header-nav__dropdown')) {
    return true;
  }
  if (el.matches('.mobile-menu__link,.mobile-menu__sublink,.mobile-menu__submenu-heading')) {
    return true;
  }
  if (el.matches('[data-open-recover],.auth-form__label-row button,.account-page__guest-btn')) {
    return true;
  }
  if (el.matches('.header-icon,.product-card__wishlist,.cart-badge,.wishlist-badge,.icon,svg,input,textarea,select,option')) {
    return true;
  }
  if (el.matches('button,a') && el.querySelector('svg') && !el.textContent.trim()) {
    return true;
  }
  return false;
}

function markReveal(el, delayIndex, className = 'text-reveal') {
  if (shouldSkipTextReveal(el)) return null;
  if (el.classList.contains(className)) return el;
  el.classList.add(className);
  el.style.setProperty('--reveal-delay', `${Math.min(delayIndex % 12, 11) * 45}ms`);
  return el;
}

function observeRevealNodes(nodes) {
  const unique = [...new Set(nodes.filter(Boolean))];
  if (!unique.length) return;

  if (!('IntersectionObserver' in window)) {
    unique.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -6% 0px' },
  );

  unique.forEach((el) => {
    if (el.classList.contains('is-visible')) return;
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.94 && rect.bottom > 0) {
      window.requestAnimationFrame(() => {
        el.classList.add('is-visible');
      });
    } else {
      observer.observe(el);
    }
  });
}

function initRevealAnimations() {
  const nodes = [];
  let delayIndex = 0;

  const blockGroups = [
    '.section-head',
    '.product-card',
    '.auto-scroll-collections__card',
    '.activity-card',
    '.color-card',
    '.promo-banner__content',
    '.video-promo__content',
    '.newsletter-hero__inner',
  ];

  blockGroups.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      const marked = markReveal(el, delayIndex++, 'reveal-on-scroll');
      if (marked) nodes.push(marked);
    });
  });

  const textSelector = [
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'p', 'li', 'label', 'figcaption', 'blockquote',
    'dt', 'dd', 'th', 'td',
    'a', 'button',
    '.product-card__badge',
    '.header-nav__link',
  ].join(',');

  const textRoots = '#main-content, .hero-section, .site-header';
  document.querySelectorAll(`${textRoots} ${textSelector}`).forEach((el) => {
    if (el.closest('.reveal-on-scroll')) return;
    const marked = markReveal(el, delayIndex++);
    if (marked) nodes.push(marked);
  });

  observeRevealNodes(nodes);
}

function validateRegistrationPassword(password) {
  if (typeof password !== 'string' || password.length < 8) return false;
  if (!/[a-z]/.test(password)) return false;
  if (!/[A-Z]/.test(password)) return false;
  if (!/[0-9]/.test(password)) return false;
  return true;
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function redirectToSignInAfterRegister(email, signInRel) {
  const signInUrl = signInRel.startsWith('http')
    ? new URL(signInRel)
    : new URL(signInRel.startsWith('/') ? signInRel : `/${signInRel}`, window.location.origin);
  signInUrl.searchParams.set('registered', '1');
  if (email) signInUrl.searchParams.set('email', email);
  window.location.assign(signInUrl.toString());
}

/** Submit hidden customer_login on register page (same user gesture → Shopify CAPTCHA). */
function attemptRegisterNativeAutoLogin(section, email, password) {
  const loginForm = section?.querySelector('[data-register-auto-login]');
  if (!(loginForm instanceof HTMLFormElement)) return false;

  const emailInput = loginForm.querySelector('input[name="customer[email]"]');
  const passwordInput = loginForm.querySelector('input[name="customer[password]"]');
  if (!(emailInput instanceof HTMLInputElement) || !(passwordInput instanceof HTMLInputElement)) {
    return false;
  }

  emailInput.value = email;
  passwordInput.value = password;

  [emailInput, passwordInput].forEach((input) => {
    input.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  window.requestAnimationFrame(() => {
    if (typeof loginForm.requestSubmit === 'function') {
      loginForm.requestSubmit();
    } else {
      loginForm.submit();
    }
  });

  return true;
}

function extractShopifyLoginAuthenticityToken(html) {
  const m1 = html.match(/name=["']authenticity_token["'][^>]*value=["']([^"']+)["']/i);
  const m2 = html.match(/value=["']([^"']+)["'][^>]*name=["']authenticity_token["']/i);
  return (m1 && m1[1]) || (m2 && m2[1]) || null;
}

function postShopifyCustomerLoginForm(email, password, returnTo, authenticityToken, loginAction) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = loginAction;
  form.style.display = 'none';

  const add = (name, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  add('form_type', 'customer_login');
  add('utf8', '\u2713');
  add('authenticity_token', authenticityToken);
  add('customer[email]', email);
  add('customer[password]', password);
  if (returnTo) add('return_to', returnTo);

  document.body.appendChild(form);
  form.submit();
}

function isRegistrationLoginRetryable(status) {
  return (
    status === 401 ||
    status === 408 ||
    status === 425 ||
    status === 429 ||
    (status >= 500 && status <= 599)
  );
}

function readRegistrationI18n(section) {
  if (!section) return {};
  const d = section.dataset;
  return {
    networkError: d.i18nNetworkError,
    signInFailed: d.i18nSignInFailed,
    loadSigninPage: d.i18nLoadSigninPage,
    csrfError: d.i18nCsrfError,
    completeSignIn: d.i18nCompleteSignIn,
  };
}

function pickErrMsg(i18n, key, fallback) {
  const v = i18n[key];
  return typeof v === 'string' && v.trim() ? v : fallback;
}

/**
 * After optional Vercel /api/login check, POST native Shopify customer_login (CSRF from sign-in page HTML).
 * Retries when invoked right after customerCreate — Shopify may need a moment before credentials work.
 */
async function establishShopifyCustomerSession(email, password, returnTo, options = {}) {
  const registrationFlow = Boolean(options.registrationFlow);
  const maxAttempts = registrationFlow ? 14 : 5;
  const gapMs = registrationFlow ? 320 : 280;
  const i18n = options.i18n || {};
  const errMsg = (key, fallback) => pickErrMsg(i18n, key, fallback);

  if (registrationFlow) {
    await delay(380);
  }

  const base = document.body.dataset.memberApiBase?.trim();
  const loginApi = base ? `${base.replace(/\/$/, '')}/api/login` : null;

  const origin = window.location.origin;
  const signInRel = document.body.dataset.memberSignIn?.trim() || '/pages/sign-in';
  const signInUrl = signInRel.startsWith('http')
    ? signInRel
    : origin + (signInRel.startsWith('/') ? signInRel : `/${signInRel}`);

  const actionRel = document.body.dataset.accountLoginUrl?.trim() || '/account/login';
  const loginAction = actionRel.startsWith('http')
    ? actionRel
    : origin + (actionRel.startsWith('/') ? actionRel : `/${actionRel}`);

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    if (loginApi) {
      let res;
      try {
        res = await fetch(loginApi, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, password }),
        });
      } catch {
        if (attempt < maxAttempts) {
          await delay(gapMs);
          continue;
        }
        throw new Error(errMsg('networkError', 'Could not reach the sign-in service. Check your connection.'));
      }

      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        if (attempt < maxAttempts && isRegistrationLoginRetryable(res.status)) {
          await delay(gapMs);
          continue;
        }
        throw new Error(
          typeof data.error === 'string' ? data.error : errMsg('signInFailed', 'Sign in failed'),
        );
      }
    }

    let html;
    try {
      const r = await fetch(signInUrl, { credentials: 'same-origin', redirect: 'follow' });
      if (!r.ok) throw new Error(errMsg('loadSigninPage', 'Could not load sign-in page'));
      html = await r.text();
    } catch (fetchErr) {
      if (attempt < maxAttempts) {
        await delay(gapMs);
        continue;
      }
      throw fetchErr instanceof Error
        ? fetchErr
        : new Error(errMsg('loadSigninPage', 'Could not load sign-in page'));
    }

    const token = extractShopifyLoginAuthenticityToken(html);
    if (!token) {
      if (attempt < maxAttempts) {
        await delay(gapMs);
        continue;
      }
      throw new Error(
        errMsg('csrfError', 'Could not prepare sign-in (CSRF). Try opening the sign-in page once.'),
      );
    }

    postShopifyCustomerLoginForm(email, password, returnTo, token, loginAction);
    return;
  }

  throw new Error(errMsg('completeSignIn', 'Could not complete sign-in. Please try again.'));
}

/**
 * When theme setting "API base URL" (Vercel) is set, validate credentials via POST /api/login
 * on that host, then submit the native customer_login form so Shopify sets the session cookie.
 */
function initMemberLoginPreflight() {
  const base = document.body.dataset.memberApiBase?.trim();
  if (!base) return;

  const loginUrl = `${base.replace(/\/$/, '')}/api/login`;

  document.querySelectorAll('[data-auth-login-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      if (!form.checkValidity()) return;
      /* Second pass: API ok — let Shopify captcha + native customer_login run. */
      if (form.dataset.loginApiPreflightOk === '1') {
        delete form.dataset.loginApiPreflightOk;
        return;
      }
      e.preventDefault();

      const errEl = form.querySelector('[data-login-api-error]');
      const submitBtn = form.querySelector('button[type="submit"]');
      if (errEl) {
        errEl.textContent = '';
        errEl.hidden = true;
      }

      const fd = new FormData(form);
      const email = String(fd.get('customer[email]') || '').trim();
      const password = String(fd.get('customer[password]') || '');
      const loginFailedMsg =
        form.closest('[data-auth-login-root]')?.dataset?.i18nLoginFailed?.trim() || '';

      if (submitBtn) submitBtn.disabled = true;
      try {
        const returnTo =
          form.querySelector('input[name="return_to"]')?.value?.trim() ||
          document.body.dataset.memberHome?.trim() ||
          '/pages/member';
        const res = await fetch(loginUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, password, returnTo }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          throw new Error(
            typeof data.error === 'string' && data.error.trim()
              ? data.error
              : loginFailedMsg || 'Sign in failed',
          );
        }
        if (typeof data.multipassUrl === 'string' && data.multipassUrl.trim()) {
          window.location.assign(data.multipassUrl.trim());
          return;
        }
        form.dataset.loginApiPreflightOk = '1';
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      } catch (err) {
        if (errEl) {
          const fallback = loginFailedMsg || 'Sign in failed';
          errEl.textContent = err instanceof Error ? err.message || fallback : fallback;
          errEl.hidden = false;
        }
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  });
}

function initRegistrationApiForm() {
  document.querySelectorAll('[data-registration-api-form]').forEach((form) => {
    const section = form.closest('[data-registration-section]');
    const apiUrl = section?.getAttribute('data-api-url');
    const errEl = form.querySelector('[data-registration-error]');
    const submitBtn = form.querySelector('[data-registration-submit]');
    if (!apiUrl || !submitBtn) return;

    const msg = (attr, fallback) => {
      const v = section?.dataset?.[attr];
      return typeof v === 'string' && v.trim() ? v : fallback;
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (errEl) {
        errEl.textContent = '';
        errEl.hidden = true;
      }

      const fd = new FormData(form);
      const email = String(fd.get('email') || '').trim();
      const password = String(fd.get('password') || '');
      const confirm = String(fd.get('confirm_password') || '');
      const firstName = String(fd.get('first_name') || '').trim();
      const lastName = String(fd.get('last_name') || '').trim();
      const newsletter = form.querySelector('[name="accepts_marketing"]');
      const acceptsMarketing = newsletter ? newsletter.checked : false;

      if (password !== confirm) {
        if (errEl) {
          errEl.textContent = msg('i18nPasswordMismatch', 'Passwords do not match');
          errEl.hidden = false;
        }
        return;
      }

      if (!validateRegistrationPassword(password)) {
        if (errEl) {
          errEl.textContent = msg(
            'i18nPasswordRules',
            'Password must be at least 8 characters and include uppercase, lowercase, and a number',
          );
          errEl.hidden = false;
        }
        return;
      }

      submitBtn.disabled = true;
      const defaultSubmitLabel = submitBtn.textContent;
      const returnTo = section.getAttribute('data-return-after-login')?.trim() || '';
      const signInRel = document.body.dataset.memberSignIn?.trim() || '/pages/sign-in';
      try {
        const res = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            password,
            firstName,
            lastName,
            acceptsMarketing,
            returnTo,
          }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          const apiMsg =
            typeof data.error === 'string'
              ? data.error + (typeof data.hint === 'string' ? ` — ${data.hint}` : '')
              : '';
          throw new Error(apiMsg || msg('i18nRegistrationFailed', 'Registration failed'));
        }

        /* Prefer Multipass → custom member page. Never rely on native /account/login
           auto-submit here: with New Customer Accounts Shopify hijacks to shopify.com. */
        if (typeof data.multipassUrl === 'string' && data.multipassUrl.trim()) {
          window.location.assign(data.multipassUrl.trim());
          return;
        }

        redirectToSignInAfterRegister(email, signInRel);
        return;
      } catch (err) {
        if (errEl) {
          errEl.textContent =
            err instanceof Error ? err.message : msg('i18nRegistrationFailed', 'Registration failed');
          errEl.hidden = false;
        }
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = defaultSubmitLabel;
      }
    });
  });
}

function initAccountInlineAddressForm() {
  document.querySelectorAll('[data-account-address-inline-root]').forEach((root) => {
    if (root.dataset.accountAddressJs === '1') return;
    root.dataset.accountAddressJs = '1';

    const toggles = root.querySelectorAll('[data-account-address-toggle]');
    const panels = root.querySelectorAll('[data-account-address-panel]');

    const closeAllPanels = () => {
      panels.forEach((item) => {
        item.hidden = true;
      });
      toggles.forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
      });
    };

    const openPanel = (panel, toggle) => {
      if (!panel) return;
      closeAllPanels();
      panel.hidden = false;
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => {
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        const first = panel.querySelector(
          'input:not([type="hidden"]):not([type="checkbox"]), select',
        );
        first?.focus();
      });
    };

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = toggle.getAttribute('data-account-address-target');
        if (!targetId) return;
        const targetPanel = root.querySelector(`#${targetId}`);
        if (!targetPanel) return;
        if (targetPanel.hidden) openPanel(targetPanel, toggle);
        else closeAllPanels();
      });
    });

    root.querySelectorAll('[data-account-address-form-cancel]').forEach((btn) => {
      btn.addEventListener('click', () => {
        closeAllPanels();
      });
    });

    const erroredPanel = root.querySelector(
      '[data-account-address-panel] .account-page__address-form-errors',
    )?.closest('[data-account-address-panel]');

    if (erroredPanel) {
      const activeToggle = root.querySelector(
        `[data-account-address-toggle][data-account-address-target="${erroredPanel.id}"]`,
      );
      openPanel(erroredPanel, activeToggle);
    }

    const mountProvince = () => {
      if (typeof Shopify === 'undefined' || typeof Shopify.CountryProvinceSelector !== 'function') {
        return;
      }

      root.querySelectorAll('[data-address-country-select]').forEach((countrySelect) => {
        if (countrySelect.dataset.provinceMounted === '1') return;
        const provinceId = countrySelect.getAttribute('data-province-target');
        const containerId = countrySelect.getAttribute('data-province-container');
        if (!provinceId || !containerId) return;
        if (!document.getElementById(countrySelect.id) || !document.getElementById(provinceId)) return;
        countrySelect.dataset.provinceMounted = '1';
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(countrySelect.id, provinceId, {
          hideElement: containerId,
        });
      });
    };

    mountProvince();
    window.setTimeout(mountProvince, 320);
  });
}

function initAuthAndAccountPages() {
  const params = new URLSearchParams(window.location.search);
  if (params.get('registered') === '1') {
    document.querySelectorAll('[data-register-success]').forEach((el) => {
      el.hidden = false;
    });
    const registeredEmail = params.get('email')?.trim();
    if (registeredEmail) {
      document
        .querySelectorAll(
          '#customer-email, [data-auth-login-form] input[name="customer[email]"]',
        )
        .forEach((input) => {
          if (input instanceof HTMLInputElement && !input.value) {
            input.value = registeredEmail;
          }
        });
    }
  }

  const isAddressesRoute = window.location.pathname.includes('/account/addresses');
  const initialAccountTab =
    params.get('tab') === 'addresses' || isAddressesRoute ? 'addresses' : 'overview';

  document.querySelectorAll('[data-auth-login-root]').forEach((root) => {
    const loginStack = root.querySelector('[data-auth-login-stack]');
    const recoverStack = root.querySelector('[data-auth-recover-stack]');
    const openBtn = root.querySelector('[data-open-recover]');
    const closeBtns = root.querySelectorAll(
      '[data-close-recover], [data-close-recover-from-back], [data-close-recover-to-login]',
    );

    if (!loginStack || !recoverStack || !openBtn) return;

    const setRecoverState = (open) => {
      loginStack.hidden = open;
      loginStack.style.display = open ? 'none' : '';
      recoverStack.hidden = !open;
      recoverStack.style.display = open ? '' : 'none';
      root.classList.toggle('auth-page--login--forgot', open);
    };

    openBtn.addEventListener('click', () => setRecoverState(true));
    closeBtns.forEach((btn) => {
      btn.addEventListener('click', () => setRecoverState(false));
    });

    if (root.querySelector('[data-recover-success-sent]')) {
      setRecoverState(true);
    } else {
      setRecoverState(false);
    }
  });

  document.querySelectorAll('.auth-page:not([data-auth-login-root])').forEach((root) => {
    const loginForm = root.querySelector('[data-auth-login-form]');
    const recoverForm = root.querySelector('[data-auth-recover-form]');
    const loginViews = root.querySelectorAll('[data-auth-login-view]');
    const recoverViews = root.querySelectorAll('[data-auth-recover-view]');
    const openBtn = root.querySelector('[data-open-recover]');
    const closeBtn = root.querySelector('[data-close-recover]');

    if (loginForm && recoverForm && openBtn && closeBtn) {
      const setRecoverState = (open) => {
        loginForm.style.display = open ? 'none' : '';
        recoverForm.style.display = open ? '' : 'none';
        loginViews.forEach((el) => {
          el.hidden = open;
        });
        recoverViews.forEach((el) => {
          el.hidden = !open;
        });
      };

      openBtn.addEventListener('click', () => setRecoverState(true));
      closeBtn.addEventListener('click', () => setRecoverState(false));
      setRecoverState(false);
    }
  });

  document.querySelectorAll('[data-account-page]').forEach((page) => {
    const buttons = page.querySelectorAll('[data-account-tab-btn]');
    const tabs = page.querySelectorAll('[data-account-tab]');

    if (buttons.length && tabs.length) {
      const setTab = (name) => {
        tabs.forEach((tab) => {
          tab.hidden = tab.getAttribute('data-account-tab') !== name;
        });
        buttons.forEach((btn) => {
          btn.classList.toggle('is-active', btn.getAttribute('data-account-tab-btn') === name);
        });
      };

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          setTab(btn.getAttribute('data-account-tab-btn'));
        });
      });
      setTab(initialAccountTab);
    }

    page.querySelectorAll('[data-account-tab-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const name = trigger.getAttribute('data-account-tab-trigger');
        const tabBtn = page.querySelector(`[data-account-tab-btn="${name}"]`);
        tabBtn?.click();
      });
    });
  });

  initMemberLoginPreflight();
  initRegistrationApiForm();
  initAccountInlineAddressForm();
}

document.addEventListener('DOMContentLoaded', syncHomeHeaderState);
document.addEventListener('DOMContentLoaded', startAnnouncementRotator);
document.addEventListener('DOMContentLoaded', initProductCards);
document.addEventListener('DOMContentLoaded', initWishlist);
document.addEventListener('DOMContentLoaded', initWishlistPage);
document.addEventListener('DOMContentLoaded', initReactParityCarousels);
document.addEventListener('DOMContentLoaded', initShopByColorProductGalleries);
document.addEventListener('DOMContentLoaded', initCustomScrollIndicators);
document.addEventListener('DOMContentLoaded', initCollectionsManualScroll);
document.addEventListener('DOMContentLoaded', initVideoPromo);
document.addEventListener('DOMContentLoaded', initRevealAnimations);
document.addEventListener('shopify:section:load', initRevealAnimations);
document.addEventListener('DOMContentLoaded', initSearchOverlay);
document.addEventListener('DOMContentLoaded', initSizeGuide);
document.addEventListener('DOMContentLoaded', initProductPage);

document.addEventListener(
  'click',
  (event) => {
    const back = event.target.closest('[data-product-back]');
    if (!back) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    window.history.back();
  },
  true,
);
document.addEventListener('DOMContentLoaded', initCookieConsent);
document.addEventListener('DOMContentLoaded', initAuthAndAccountPages);
document.addEventListener('DOMContentLoaded', initHeaderNavDropdowns);
document.addEventListener('DOMContentLoaded', initFooterLangDropdowns);

document.addEventListener(
  'click',
  (event) => {
    const wishToggle = event.target.closest('[data-wishlist-toggle]');
    if (!wishToggle) return;
    const handle = wishToggle.getAttribute('data-product-handle');
    if (!handle) return;
    event.preventDefault();
    event.stopPropagation();
    try {
      toggleWishlistProduct(handle);
      notifyWishlistUpdated();
    } catch {
      /* ignore */
    }
  },
  true,
);

document.addEventListener('shopify:section:load', () => {
  syncWishlistButtons();
  void refreshWishlistPageFromStorage();
  initAccountInlineAddressForm();
  initHeaderNavDropdowns();
  initFooterLangDropdowns();
  initShopByColorProductGalleries();
});

window.addEventListener('storage', (event) => {
  if (event.key !== WISHLIST_LS_KEY) return;
  notifyWishlistUpdated();
});

window.addEventListener('scroll', syncHomeHeaderState, { passive: true });
window.addEventListener('resize', syncHomeHeaderState, { passive: true });
window.addEventListener('resize', () => {
  if (document.body.classList.contains('search-open') || document.querySelector('.site-header.nav-dropdown-open')) {
    syncSearchOverlayHeaderOffset();
  }
}, { passive: true });

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-mobile-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const header = document.querySelector('.site-header');
    if (menu) {
      const isOpen = menu.getAttribute('data-open') === 'true';
      const nextState = String(!isOpen);
      menu.setAttribute('data-open', nextState);
      toggle.setAttribute('aria-expanded', nextState);
      const labels = getMenuAriaLabels();
      toggle.setAttribute('aria-label', isOpen ? labels.open : labels.close);
      if (header) {
        header.classList.toggle('menu-open', !isOpen);
      }
      if (isOpen) {
        closeAllNavDropdowns();
      } else {
        document.querySelectorAll('[data-mobile-submenu]').forEach((item) => {
          const panel = item.querySelector('[data-mobile-submenu-panel]');
          item.classList.remove('is-open');
          item.querySelector('[data-mobile-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
          if (panel) panel.hidden = true;
        });
      }
    }
  }

  const searchOpen = event.target.closest('[data-search-open]');
  if (searchOpen) {
    event.preventDefault();
    setSearchOverlayState(true);
  }

  const mobileSubmenuToggle = event.target.closest('[data-mobile-submenu-toggle]');
  if (mobileSubmenuToggle) {
    event.preventDefault();
    const item = mobileSubmenuToggle.closest('[data-mobile-submenu]');
    if (!item) return;
    setMobileSubmenuOpen(item, !item.classList.contains('is-open'));
    return;
  }

  if (!event.target.closest('[data-nav-dropdown]')) {
    closeAllNavDropdowns();
  }

  if (!event.target.closest('[data-footer-lang-dropdown]')) {
    closeFooterLangDropdowns();
  }

  const searchClose = event.target.closest('[data-search-close]');
  if (searchClose) {
    event.preventDefault();
    setSearchOverlayState(false);
  }

  const cartToggle = event.target.closest('[data-cart-toggle]');
  if (cartToggle) {
    const drawer = document.querySelector('[data-cart-drawer]');
    const isOpen = drawer?.getAttribute('data-open') === 'true';
    if (isOpen) {
      setCartDrawerState(false);
    } else {
      void (async () => {
        await window.refreshCartDrawer?.();
        setCartDrawerState(true);
      })();
    }
  }

  const cartClose = event.target.closest('[data-cart-close]');
  if (cartClose) {
    setCartDrawerState(false);
  }

  const left = event.target.closest('[data-autoscroll-left]');
  const right = event.target.closest('[data-autoscroll-right]');
  if (left || right) {
    const row = event.target.closest('.auto-scroll-collections__row');
    const viewport = row?.querySelector('[data-autoscroll-viewport]');
    if (viewport) {
      const amount = 300;
      viewport.scrollBy({
        left: left ? -amount : amount,
        behavior: 'smooth',
      });
    }
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  if (getSizeGuideRoot()?.getAttribute('data-open') === 'true') {
    closeSizeGuide();
    return;
  }
  const overlay = document.querySelector('[data-search-overlay]');
  if (overlay?.getAttribute('data-open') === 'true') {
    setSearchOverlayState(false);
    return;
  }
  if (document.querySelector('[data-nav-dropdown].is-open')) {
    closeAllNavDropdowns();
    return;
  }
  setCartDrawerState(false);
});
